export default __webpack_public_path__ + "/dist/images/expert-contentimg.png";